import i18n from './i18n';
import breakpoint from './breakpoint';
import init from './jquery.init';
import validity from './jquery.validity';
import './jquery.transitionDuration';
import './init/dataIf';
import 'select2/dist/js/select2.full.js';
import './dragscroll';
import $ from 'jquery';
import { showModal } from '../components/b-modal';
import * as Sentry from '@sentry/browser';

window.i18n = i18n;

window.jQuery = window.$ = $;

$.showModal = showModal;

function updateScrollbarWidth() {
	var root = document.documentElement;
	root.style.setProperty('--window-scrollbar-width', (window.innerWidth - root.clientWidth) + 'px');
}
window.addEventListener('resize', updateScrollbarWidth);
$(updateScrollbarWidth);


const initSentry = () => {
	const body = document.querySelector('body');
	if (body.dataset.sentry) {
			Sentry.init({
				dsn: 'https://c67dbeaf695437c8c6a7fdb5dc0c9e3f@o4507576320393216.ingest.de.sentry.io/4507576806342736',
				release: "ancor@0.0.1",
				integrations: [
					Sentry.browserTracingIntegration(),
					Sentry.replayIntegration(),
				],
				tracesSampleRate: 1.0,
				tracePropagationTargets: ["localhost", /^https:\/\/d1\-36\.sentry\.io\/api/],
				replaysSessionSampleRate: 0.1,
				replaysOnErrorSampleRate: 1.0,
			})
	}
}

document.addEventListener('DOMContentLoaded', initSentry)